import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';
 
@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppFloatingConfigurator, ButtonModule],
    template: ` <app-floating-configurator />
        <div class="flex items-center justify-center min-h-screen overflow-hidden">
             <div class="flex items-center justify-center min-h-screen">
            <div class="text-center">
                <h1 class="text-5xl font-bold text-primary mb-4">404</h1>
                <h2 class="text-2xl font-semibold mb-2">Page Not Found</h2>
                <p class="text-lg text-gray-600 mb-6">
                    Sorry, the page you are looking for does not exist or has been moved.
                </p>
           
            </div>
        </div>
        </div>`
})
export class Notfound {}